import { z } from 'zod';

/**
 * Login form validation.
 *
 * Deliberately permissive on the identifier: the backend accepts a username, a
 * mobile number or an email in the same field and resolves them in that order
 * (UT system/Services/UsersService.cs:205-211). Validating it as an email would
 * lock out the username and MSISDN cases.
 *
 * The password rule is presence-only. Enforcing a minimum length on *login*
 * tells an attacker about the password policy and annoys users with legacy
 * short passwords; complexity rules belong on registration and change-password.
 */
export const loginSchema = z.object({
  userName: z.string().trim().min(1, 'Enter your username, email or mobile number.'),
  password: z.string().min(1, 'Enter your password.'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
